import { useEffect } from "react"
import { isUnAuthorize } from "../shared"
import { Navigate } from "react-router-dom"

const Protected = ({ children }) => {
    useEffect(()=>{
        if(isUnAuthorize())
            localStorage.clear()
    },[])

      if (isUnAuthorize()) {
        // message.error('You need to log in to access this page.');
         return <Navigate to="/login" replace />;
    
      }
      return children
}
export default Protected;
